import * as React from "react";
const SvgBubbleTail = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", overflow: "visible", style: {
  display: "block"
}, width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Polygon 1", d: "M0 0L8 8H0V0Z", fill: "#F4F4F4" }));
export default SvgBubbleTail;
